<template>
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

  <VDialog v-model="dialogLoading" :max-width="700">
    <VCard class="pa-sm-10 pa-5">
      <VCardTitle class="text-center">Cargando información</VCardTitle>
      <VProgressLinear indeterminate color="primary"></VProgressLinear>
    </VCard>
  </VDialog>
  
    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content report-box  container-fluid">
  
        <div>
          <h1>{{ $store.getters.currentLanguage === 'en' ? 'Welcome' : 'Bienvenido' }}</h1>
        </div>
        <!-- Page Header -->
        <div class="page-header subscribe-head">
          <div class="row align-items-center">
            <breadcrumbthree :title="title" :text="text" :text1="text1" />
  
            <div class="col-auto">
              <a
                class="btn add-user"
                href="javascript:;"
                data-bs-toggle="modal"
                data-bs-target="#add_joboffer"
              >
                <i class="fas fa-plus"></i> Agregar Registro
              </a>
            </div>
          </div>
        </div>
        <!-- /Page Header -->
  
        <div class="row">
          <div class="col-sm-12">
            <div class="card">
              <div class="card-body">
                <div class="showentries">
                  <label
                    >Mostrar
                    <select>
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                    Registros
                  </label>
                  <div class="entries">
                    <span>Buscar: </span>
                    <input
                      type="search"
                      class="form-control form-control-sm ms-2"
                      placeholder=""
                      aria-controls="DataTables_Table_0"
                      v-model = "searched_value"
                      @input="localSearch()"
                    />
                  </div>
                </div>
                <div class="table-responsive">
                  <a-table
                    class="stripped table-hover"
                    :columns="columnsTableJobOffers"
                    :data-source="dataTableFiltJobOffers"
                  >
                    <template #bodyCell="{ column, record }">
                      <template v-if="column.key === 'parrafo'">
                          <div>{{ record.parrafo }}</div>
                      </template>
                      <template v-if="column.key === 'imagenUrl'">
                          <div><img :src="record.imagenUrl" style="max-width:64px"/></div>
                      </template>
                      <template v-if="column.key === 's3_url'">
                          <div><img :src="record.s3_url" style="max-width:64px"/></div>
                      </template>
                      <template v-else-if="column.key === 'id'">
                        <div class="text-end">
                          <a
                          href="javascript:void(0);"
                          class="btn btn-sm btn-agv-dos me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#add_joboffer"
                          @click="loadCloneModalJobOffer(record)"
                          title="Clonar oferta"
                          ><i class="fa-regular fa-clone"></i>
                          </a>
                          <a
                          href="javascript:void(0);"
                          class="btn btn-sm btn-primary me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#ver-oferta"
                          @click="getApplicantsByOffer(record.id, record)"
                          title="Ver oferta"
                          ><i class="far fa-eye"></i>
                          </a>
                          <a
                            href="javascript:void(0);"
                            class="btn btn-sm btn-secondary me-2"
                            data-bs-toggle="modal"
                            data-bs-target="#add_joboffer"
                            @click="loadEditModalCollaborator(record)"
                            ><i class="far fa-edit"></i
                          ></a>
                          <a
                          href="javascript:void(0);"
                          class="btn btn-sm btn-danger"
                          data-bs-toggle="modal"
                          data-bs-target="#delete_collaborator"
                          @click="loadDeleteModalJobOffer(record)"
                          title="Eliminar oferta"
                          ><i class="far fa-trash-alt"></i>
                          </a>
                        </div>
                      </template>
                    </template>
                  </a-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Wrapper -->
  
    <!-- Add Modal -->
    <div class="modal fade custom-modal" id="add_joboffer" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">Crear Oferta Laboral</h4>
            <button type="button" class="close" data-bs-dismiss="modal">
              <span>&times;</span>
            </button>
          </div>
  
          <!-- Modal body -->
          <div class="modal-body">
            <form @submit.prevent="validateAndSubmit" class="needs-validation" novalidate>

                <!-- NUEVA OFERTA LABORAL -->
                <div class="cont_new_job_offer">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Puesto</label>
                                <input 
                                    type="text" 
                                    class="form-control" 
                                    v-model="work_position" 
                                    required
                                    @input="e2 => work_position = e2.target.value.toUpperCase()"
                                />
                                <div class="invalid-feedback">Por favor ingresa el puesto</div>
                            </div>
                        </div>
                        <!-- <div class="col-md-6">
                            <div class="form-group">
                                <label>Complemento (Opcional)</label>
                                <input 
                                type="text" 
                                class="form-control" 
                                v-model="complement"
                                required
                                />
                                <div class="invalid-feedback">
                                    Por favor ingresa el complemento
                                </div>
                            </div>
                        </div> -->
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>N° Vacantes</label>
                                <input 
                                type="number" 
                                class="form-control" 
                                v-model="n_vacancy" 
                                required
                                />
                                <div class="invalid-feedback">
                                    Por favor ingresa el n° vacantes
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                  <label>Fecha de Contratación</label>
                                  <datepicker
                                    v-model="date_hire"
                                    placeholder="Choose Date"
                                    class="form-control datetimepicker"
                                    :editable="true"
                                    :clearable="false"
                                    @update:model-value="handleDate"
                                  />
                                <div class="invalid-feedback">
                                    Por favor ingresa el complemento
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-md-4">
                            <div class="form-group">
                                <label>Referencia</label>
                                <input 
                                type="text" 
                                class="form-control" 
                                v-model="reference" 
                                required
                                />
                                <div class="invalid-feedback">
                                    Por favor ingresa la referencia
                                </div>
                            </div>
                        </div> -->
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Modalidad de Trabajo</label>
                                <select 
                                class="form-control form-select" 
                                v-model="selectedWorkModality" 
                                required
                                >
                                    <option 
                                    v-for="wm in work_modalities" 
                                    :key="wm.value" 
                                    :value="wm.value"
                                    >
                                    {{ wm.text }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Tipo de contrato</label>
                                <select 
                                class="form-control form-select" 
                                v-model="selectedTypeContract" 
                                required
                                >
                                    <option 
                                    v-for="tc in types_contracts" 
                                    :key="tc.value" 
                                    :value="tc.value"
                                    >
                                    {{ tc.text }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Jornada Laboral</label>
                                <select 
                                class="form-control form-select" 
                                v-model="selectedWorkingDay" 
                                required
                                >
                                    <option 
                                    v-for="lj in labor_journeys" 
                                    :key="lj.value" 
                                    :value="lj.value"
                                    >
                                    {{ lj.text }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Lugar</label>
                                <select 
                                class="form-control form-select" 
                                v-model="selectedPlace" 
                                required
                                >
                                    <option 
                                    v-for="p in places" 
                                    :key="p.value" 
                                    :value="p.value"
                                    >
                                    {{ p.text }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Area</label>
                                <input 
                                type="text" 
                                class="form-control" 
                                v-model="area" 
                                required
                                @input="e2 => area = e2.target.value.toUpperCase()"
                                />
                                <div class="invalid-feedback">
                                    Por favor ingresa el area
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Periodo</label>
                                <select 
                                class="form-control form-select" 
                                v-model="selectedPeriod" 
                                required
                                >
                                    <option 
                                    v-for="p in periods" 
                                    :key="p.value" 
                                    :value="p.value"
                                    >
                                    {{ p.text }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Descripción del Aviso:</label>
                                <div ref="descriptionEditor" class="quill-editor"></div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Funciones:</label>
                                <div ref="functionsEditor" class="quill-editor"></div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Requisitos:</label>
                                <div ref="requirementsEditor" class="quill-editor"></div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Tiempo de Experiencia</label>
                                <select 
                                class="form-control form-select" 
                                v-model="selectedExperienceTime" 
                                required
                                >
                                    <option 
                                    v-for="et in experiencie_time" 
                                    :key="et.value" 
                                    :value="et.value"
                                    >
                                    {{ et.text }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Nivel de Educación</label>
                                <select 
                                class="form-control form-select" 
                                v-model="selectedLevelEducation" 
                                required
                                >
                                    <option 
                                    v-for="le in levelseducation" 
                                    :key="le.value" 
                                    :value="le.value"
                                    >
                                    {{ le.text }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                            <label>Imagen</label>
                                <input 
                                type="file" 
                                class="form-control" 
                                name="txt-imagen" 
                                accept="image/png, image/gif, image/jpeg"
                                @change="handlePhotoChangeJobOffer"
                                />
                                <div class="img-preview">
                                    <img v-if="img_preview_joboffer" :src="img_preview_joboffer"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <label style="width:100%; text-align:center; margin-top: 30px;">Preguntas del Cuestionario</label>
                        <table class="table_quiz_questions" style="width:100%">
                          <thead>
                            <tr>
                              <td>Pregunta</td>
                              <td>Tipo</td>
                              <td>Tiempo</td>
                              <td>*</td>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(q, index) in quiz_questions" :key="index">
                              <td>{{q.question}}</td>
                              <td>{{q.type_quest}}</td>
                              <td>{{q.time_quest}} seg</td>
                              <td>
                                <a
                                href="javascript:void(0);"
                                class="btn btn-sm btn-danger"
                                @click="deleteQuestion"
                                ><i class="far fa-trash-alt"></i></a>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        <a
                        class="btn btn-agv-dos mt-2"
                        href="javascript:;"
                        @click="openAddQuestionModal"
                        >
                          <i class="fas fa-plus"></i> Agregar pregunta
                        </a>
                      </div>
                    </div>
                </div>

                <div class="mt-4">
                    <button 
                    type="submit" 
                    class="btn btn-agv-dos btn-block" 
                    >
                    <!-- data-bs-dismiss="modal" -->
                    Guardar
                    </button>
                </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- /Add Modal -->
 
    <!-- Edit Modal -->
    <div class="modal fade custom-modal" id="">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">Editar Registro</h4>
            <button type="button" class="close" data-bs-dismiss="modal">
              <span>&times;</span>
            </button>
          </div>
  
          <!-- Modal body -->
          <div class="modal-body">
            <form @submit.prevent="">
              <div class="form-group">
                <label>Párrafo</label>
                <textarea 
                  class="form-control" 
                  name="txt-parrafo" 
                  style="min-height:140px"  
                  placeholder="Párrafo"
                  >
                  <!-- v-model="" -->
                </textarea>
              </div>
              <div class="form-group">
                <label>Imagen</label>
                <input 
                type="file" 
                class="form-control" 
                name="txt-imagen" 
                accept="image/png, image/gif, image/jpeg"
                @change="handlePhotoChangeJobOffer"
                />
                <div class="img-preview">
                  <img :src="img_preview_joboffer"/>
                </div>
              </div>
              <div class="mt-4">
                <button type="submit" class="btn btn-agv-dos btn-block" data-bs-dismiss="modal">Guardar</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- /Edit Modal -->
    <!-- Delete modal -->
    <div class="modal custom-modal fade" id="delete_collaborator" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <div class="form-header">
              <h3>Eliminar</h3>
              <p>¿Esta seguro de eliminar este registro de forma permanente?</p>
            </div>
            <div class="modal-btn delete-action">
              <div class="row">
                <div class="col-6">
                  <a 
                    href="javascript:void(0);" 
                    class="btn btn-agv-dos continue-btn" 
                    data-bs-dismiss="modal" 
                    @click="deleteJobOffer(record)"
                    >
                  Eliminar
                  </a>
                </div>
                <div class="col-6">
                  <a
                    href="javascript:void(0);"
                    data-bs-dismiss="modal"
                    class="btn btn-agv-dos cancel-btn"
                    >Cancelar</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Delete modal -->

    <!-- Add Question Modal -->
    <div class="modal custom-modal" id="add_question" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="form-header">
                        <h3>Agregar Pregunta</h3>
                        <button type="button" class="close" data-bs-dismiss="modal">
                          <span>&times;</span>
                        </button>
                    </div>
                    <form @submit.prevent="addQuestion">
                        <!-- <div class="form-group">
                            <label>Tipo</label>
                            <select v-model="newQuestion.type" class="form-control" required>
                                <option value="A">Abierta</option>
                                <option value="C">Cerrada</option>
                            </select>
                        </div> -->
                        <div class="form-group">
                          <!-- <label class="form-label">Tipo</label> -->
                          <div class="radio row">
                            <div class="col-md-6" style="margin:auto;">
                              <label class="custom_radio me-2">
                                <input 
                                type="radio" 
                                value="A" 
                                v-model="newQuestion.type_quest" 
                                checked>
                                <span class="checkmark"></span> Abierta
                                <br>
                                <span style="color:#9B9B9B; font-size:11px;">
                                  Postulante selecciona una alternativa
                                </span>
                              </label>
                            </div>
                            <div class="col-md-6">
                              <label class="custom_radio">
                                <input 
                                type="radio" 
                                value="C" 
                                v-model="newQuestion.type_quest">
                                <span class="checkmark"></span> Cerrada
                                <br>
                                <span style="color:#9B9B9B; font-size:11px;">
                                  Postulante incluye texto abierto
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="form-group">
                            <!-- <label>Pregunta</label> -->
                            <input 
                            type="text" 
                            v-model="newQuestion.question" 
                            class="form-control" 
                            placeholder="Pregunta (Obligatorio)"
                            required
                            @input="e2 => newQuestion.question = e2.target.value.toUpperCase()">
                        </div>
                        <div v-if="newQuestion.type_quest=='C'" class="form-group">
                          <label>Alternativas</label>
                          <div class="row">
                            <div class="col-md-8">
                              <input 
                              type="text" 
                              v-model="newQuestion.alt_one" 
                              class="form-control mt-2" 
                              placeholder="Alternativa 1 (Obligatorio)"
                              @input="e2 => newQuestion.alt_one = e2.target.value.toUpperCase()"
                              >
                            </div>
                            <div class="col-md-4">
                              <input 
                              type="text" 
                              v-model="newQuestion.weight_one" 
                              class="form-control mt-2" 
                              placeholder="Peso 1"
                              @input="e2 => newQuestion.weight_one = e2.target.value.toUpperCase()"
                              >
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-8">
                              <input 
                              type="text" 
                              v-model="newQuestion.alt_two" 
                              class="form-control mt-2" 
                              placeholder="Alternativa 2 (Obligatorio)"
                              @input="e2 => newQuestion.alt_two = e2.target.value.toUpperCase()"
                              >
                            </div>
                            <div class="col-md-4">
                              <input 
                              type="text" 
                              v-model="newQuestion.weight_two" 
                              class="form-control mt-2" 
                              placeholder="Peso 2"
                              @input="e2 => newQuestion.weight_two = e2.target.value.toUpperCase()"
                              >
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-8">
                              <input 
                              type="text" 
                              v-model="newQuestion.alt_three" 
                              class="form-control mt-2" 
                              placeholder="Alternativa 3 (Opcional)"
                              @input="e2 => newQuestion.alt_three = e2.target.value.toUpperCase()"
                              >
                            </div>
                            <div class="col-md-4">
                              <input 
                              type="text" 
                              v-model="newQuestion.weight_three" 
                              class="form-control mt-2" 
                              placeholder="Peso 3"
                              @input="e2 => newQuestion.weight_three = e2.target.value.toUpperCase()"
                              >
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-8">
                              <input 
                              type="text" 
                              v-model="newQuestion.alt_four" 
                              class="form-control mt-2" 
                              placeholder="Alternativa 4 (Opcional)"
                              @input="e2 => newQuestion.alt_four = e2.target.value.toUpperCase()"
                              >
                            </div>
                            <div class="col-md-4">
                              <input 
                              type="text" 
                              v-model="newQuestion.weight_four" 
                              class="form-control mt-2" 
                              placeholder="Peso 4"
                              @input="e2 => newQuestion.weight_four = e2.target.value.toUpperCase()"
                              >
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-8">
                              <input 
                              type="text" 
                              v-model="newQuestion.alt_five" 
                              class="form-control mt-2" 
                              placeholder="Alternativa 5 (Opcional)"
                              @input="e2 => newQuestion.alt_five = e2.target.value.toUpperCase()"
                              >
                            </div>
                            <div class="col-md-4">
                              <input 
                              type="text" 
                              v-model="newQuestion.weight_five" 
                              class="form-control mt-2" 
                              placeholder="Peso 5"
                              @input="e2 => newQuestion.weight_five = e2.target.value.toUpperCase()"
                              >
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-8">
                              <input 
                              type="text" 
                              v-model="newQuestion.alt_six" 
                              class="form-control mt-2" 
                              placeholder="Alternativa 6 (Opcional)"
                              @input="e2 => newQuestion.alt_six = e2.target.value.toUpperCase()"
                              >
                            </div>
                            <div class="col-md-4">
                              <input 
                              type="text" 
                              v-model="newQuestion.weight_six" 
                              class="form-control mt-2" 
                              placeholder="Peso 6"
                              @input="e2 => newQuestion.weight_six = e2.target.value.toUpperCase()"
                              >
                            </div>
                          </div>
                        </div>
                        <!-- <div class="form-group">
                            <label>Tiempo(Segundos)</label>
                            <input 
                            type="number" 
                            v-model="newQuestion.time_quest"
                            class="form-control" 
                            >
                        </div> -->
                        <div class="form-group text-center">
                          <div class="row justify-content-end">
                            <div class="col-md-3">
                              <button 
                              type="submit" 
                              class="btn btn-agv-dos" 
                              style="width:100%"
                              >
                              Agregar
                              </button>
                            </div>
                            <div class="col-md-3">
                              <button 
                              type="button" 
                              class="btn" 
                              data-bs-dismiss="modal" 
                              style="
                                border: 1px solid #6BB545; 
                                color: #6BB545;
                                width:100%"
                              >
                              Cancelar
                              </button>
                            </div>
                          </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <!-- View Offer and Applicants Modal -->
    <div class="modal fade custom-modal" id="ver-oferta">
      <div class="modal-dialog modal-dialog-centered modal-fullscreen modal-fullscreen-lg-down">
        <div class="modal-content">

          <div class="modal-header">
            <h3 class="modal-title agv-color">Ver Oferta Laboral</h3>
            <button type="button" class="close" data-bs-dismiss="modal">
              <span>&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="franja-titulo">
                <div class="row mb-3">
                  <div class="col-md-1" style="border-right: 1px solid #6BB545;">
                    <img src="@/assets/img/agv_logo.jpg" class="img-fluid" alt="Logo" style="width:85%; margin-left:15%;"/>
                  </div>
                  <div class="col-md-11">
                    <div class="info_work_pos">
                      <h6><i class="fa-solid fa-briefcase agv-color"></i> Cargo: {{ all_info_offer_selected['work_pos'] }} / <i class="fa-solid fa-location-dot agv-color"></i> Lugar: {{ all_info_offer_selected['place'] }} / <i class="fa-solid fa-users agv-color"></i> Vacantes: {{ all_info_offer_selected['n_vacancy'] }}</h6>
                      <h6><i class="fa-solid fa-clock agv-color"></i> Experiencia: {{ all_info_offer_selected['experience_time'] }} / <i class="fa-solid fa-graduation-cap agv-color"></i> Educación: {{ all_info_offer_selected['level_education'] }} / <i class="fa-solid fa-calendar-check agv-color"></i> Periodo: {{ all_info_offer_selected['period'] }}</h6>
                      <h6><i class="fa-solid fa-file-contract agv-color"></i> Tipo Contrato: {{ all_info_offer_selected['type_contract'] }} / <i class="fa-solid fa-laptop agv-color"></i> Modalidad: {{ all_info_offer_selected['work_modality'] }}</h6>
                    </div>
                  </div>
                </div>
                <div class=".row franja-titulo-subtitulo">
                    <ul class="nav nav-tabs">
                        <li class="nav-item">
                            <a class="nav-link active" href="#tab-inscritos" data-bs-toggle="tab" @click="changeSection">
                                <span class="nav-tab-span">Inscritos ({{list_applicants.length}}) <i style="padding-left:20px;" class="fa fa-chevron-right"></i> </span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="#tab-finalistas" data-bs-toggle="tab" @click="changeSection">
                                <span class="nav-tab-span">Pre-Seleccionados ({{list_applicants_finalists.length}}) <i style="padding-left:20px;" class="fa fa-chevron-right"></i> </span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="#tab-contratados" data-bs-toggle="tab" @click="changeSection">
                                <span class="nav-tab-span"> Contratados ({{list_applicants_hired.length}}) <i style="padding-left:20px;" class="fa fa-chevron-right"></i></span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="#tab-descartados" style="background-color: lightgray;" data-bs-toggle="tab" @click="changeSection">
                                <span class="nav-tab-span">Descartados ({{list_applicants_discarded.length}})</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="tab-content">
              <div class="tab-pane show active" id="tab-inscritos">
                <div class="zona-mostrar row">
                  <div class="col-md-4 zona-mostrar-lista" style="height:100vh;">
                    <div v-for="(a, index) in list_applicants" :key="index" class="mostrar-persona" @click="getDetailsApplicant(a.id)">
                      <div class="row mostrar-persona-img" style="border-bottom: 0.5px solid lightgray; padding-bottom: 10px; cursor:pointer">
                        <div class="col-md-3">
                          <img class="rounded-circle"
                          alt="User Image"
                          :src="a.s3_url" 
                          style="margin-left:-10px; width:100px; height:100px;"/>
                        </div>
                        <div class="col-md-9">
                          <h5 style="font-size: 14px; margin-top: 7px;">{{ a.name + ' ' + a.first_surname + ' ' + a.second_surname }}</h5>
                          <p style="font-size: 12px; margin-top:-5px;">Nacimiento: {{ a.date_birthdate }}</p>
                          <p style="font-size: 12px; margin-top:-10px;">{{ a.province }} - {{ a.departament }}</p>
                          <p style="font-size: 12px; margin-top:-10px;">Fecha Postulacion: {{ a.date_application }}</p>
                        </div>
                      </div>
                    </div>
                    <div v-if="list_applicants.length == 0" class="row mostrar-persona-img" style="border-bottom: 0.5px solid #888888; padding-bottom: 10px;">
                      <span style="color:#888888; padding: 25px 0;"> Aún no hay postulantes inscritos
                        <!-- <i style="padding-left:20px;" class="fa fa-chevron-right"></i> -->
                      </span>
                    </div>
                  </div>
                  <div class="col-md-8 zona-mostrar-seleccion" style="height:100vh;">
                    <div class="blk-botonera-aprobacion" v-if="detailsApplicant.id">
                        <button class="btn btn-danger" @click="processApplicant('D', detailsApplicant.id)"><i class="fa fa-cancel" style="padding-right:6px"></i>Descartar</button>
                        <button class="btn btn-success" @click="processApplicant('P', detailsApplicant.id)"><i class="fa fa-arrow-right" style="padding-right:6px"></i> A Pre-Seleccionado</button>
                    </div>

                    <div class="row blk-cabecera mt-2" v-if="detailsApplicant.id">
                        <div class="col-md-4 blk-cabecera-img">
                            <img class="avatar-img rounded-circle" alt="User Image" :src="detailsApplicant.s3_url" style="width:90%; height:auto;"/>
                        </div>
                        <div class="col-md-8">
                            <h4 class="_title">{{detailsApplicant.name + ' ' + detailsApplicant.first_surname + ' ' + detailsApplicant.second_surname}}</h4>
                            <p class="_detail"><span><i class="fa-solid fa-calendar-days agv-color"></i> Nacimiento: {{ detailsApplicant.date_birthdate }} <i class="fa-solid fa-venus-mars agv-color"></i> {{ detailsApplicant.gender }}</span> </p>
                            <p class="_subdetail"><span><i class="fa-solid fa-location-dot agv-color"></i> Lugar: {{ detailsApplicant.departament }} | {{ detailsApplicant.province }} | {{ detailsApplicant.district }}</span></p>
                            <p class="_subdetail"><i class="fa-solid fa-calendar-check agv-color"></i> Fecha Postulacion: {{ detailsApplicant.date_application }}</p>
                            <div class="row">
                                <div class="col-sm-4 _fono">
                                    <a><i class="fa fa-phone agv-color"></i> {{detailsApplicant.n_phone}}</a>
                                </div>
                                <div class="col-sm-8 _subdetail">
                                    <i class="fa fa-envelope agv-color"></i>  {{detailsApplicant.email}}
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-sm-4 _fono">
                                    <!-- <a><i class="fa-solid fa-venus-mars"></i> {{ detailsApplicant.gender }}</a> -->
                                    <a><i class="fa-solid fa-flag agv-color"></i> {{ detailsApplicant.nationality }}</a>
                                </div>
                                <div class="col-sm-8 _subdetail">
                                  <i class="fa-solid fa-id-card agv-color"></i>  {{detailsApplicant.n_doc}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="blk-info mt-3" v-if="detailsApplicant.id">
                        <div class="blk-subinfo">
                            <h5>
                              <i class="fa-solid fa-user agv-color"></i> Perfil y objetivos: 
                              <a
                              href="javascript:void(0);"
                              class="btn btn-sm btn-primary"
                              @click="viewAnswers(detailsApplicant.id)"
                              style="font-size:14px;margin-left:10px;"
                              ><i class="far fa-eye"> Respuestas</i>
                              <!-- data-bs-toggle="modal"
                              data-bs-target="#view_answers" -->
                              </a>
                            </h5>

                            <div class="flex-dos-cols">
                                <!-- <div><strong>Resumen</strong></div> -->
                                <div class="text-justify">{{detailsApplicant.pers_description}}</div>
                            </div>
                            <div class="mt-3">
                                <!-- <div><strong>CV Adjunto</strong></div> -->
                                <div>
                                  <a
                                  :href="detailsApplicant.cv_s3_url"
                                  class="btn btn-sm btn-agv-dos"
                                  style="font-size:14px;margin-left:10px;"
                                  target="_blank"
                                  ><i class="fa-solid fa-file-lines"> Ver CV</i>
                                  </a>
                                </div>
                            </div>
                        </div>

                        <div class="blk-subinfo mt-4" style="border-top: 0.5px solid lightgray; padding-top:10px;">
                            <h5><i class="fa-solid fa-clock agv-color"></i> Experiencia: </h5>
                            <div v-for="el, index of ExpLabApplicant" :key="index" class="flex-dos-cols">
                                <div class="col-left">
                                    <strong>{{ formatDate(el.start_date)}} - {{ el.present == true ? 'Actualidad' : formatDate(el.end_date) }}</strong>
                                    <!-- <p class="text-body-tertiary">(3 años y 1 mes)</p> -->
                                </div>
                                <div>
                                    <strong>{{ el.work_pos }}</strong>
                                    <div class="text-body-tertiary">{{ el.company }}</div>
                                    <div class="text-justify">{{ el.description }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="blk-subinfo mt-4" style="border-top: 0.5px solid lightgray; padding-top:10px;">
                            <h5><i class="fa-solid fa-graduation-cap agv-color"></i> Formación:</h5>
                            <div  v-for="e, index of educationApplicant" :key="index" class="flex-dos-cols">
                                <div class="col-left">
                                  <strong>{{ formatDate(e.start_date) }} - {{ e.present == true ? 'Actualidad' : formatDate(e.end_date)  }}</strong>
                                </div>
                                <div>
                                    <strong>{{ e.career }}</strong>
                                    <div>{{ e.inst_univ }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="blk-subinfo mt-4" style="border-top: 0.5px solid lightgray; padding-top:10px; padding-bottom: 30px;">
                            <h5><i class="fa-solid fa-circle-info agv-color"></i> Información Adicional:</h5>
                            <div>
                                <div><i class="fa fa-check agv-color mr-2"></i> Licencia de conducir: {{ detailsApplicant.drivers_license == true ? 'SI' : 'NO' }}</div>
                                <div><i class="fa fa-check agv-color mr-2"></i> Disponibilidad de viajar:  {{ detailsApplicant.availab_change_travel == true ? 'SI' : 'NO' }}</div>
                                <div><i class="fa fa-check agv-color mr-2"></i> Disponibilidad de cambio de residencia:  {{ detailsApplicant.availab_change_resid == true ? 'SI' : 'NO' }}</div>
                            </div>
                        </div>

                        <!-- <div class="blk-subinfo mt-4" style="border-top: 0.5px solid lightgray; padding-top:10px;">
                            <h5><i class="fa-solid fa-magnifying-glass agv-color"></i> Datos Personales y de contacto</h5>
                            <div>
                                <div><strong>{{ detailsApplicant.name + ' ' + detailsApplicant.first_surname + ' ' + detailsApplicant.second_surname }}</strong></div>
                                <div class="text-body-tertiary">Sexo: {{ detailsApplicant.gender }} (Fec. nacimiento: {{ detailsApplicant.birthdate }})</div>
                                <div class="text-body-tertiary">{{ detailsApplicant.nationality }} - DNI: {{ detailsApplicant.n_doc }}</div>
                                <div class="text-info" style="font-size: .8em;">
                                    <i class="fa fa-phone"></i> {{ detailsApplicant.n_phone }}
                                </div>
                                <div class="text-info" style="font-size: .8em;">
                                    <i class="fa fa-envelope"></i> {{ detailsApplicant.email }}
                                </div>
                            </div>
                        </div> -->
                    </div>
                  </div>
                </div>
              </div>

              <div class="tab-pane show" id="tab-finalistas">
                <div class="zona-mostrar row">
                  <div class="col-md-4 zona-mostrar-lista" >
                    <div v-for="(a, index) in list_applicants_finalists" :key="index" class="mostrar-persona" @click="getDetailsApplicant(a.id)">
                      <div class="row mostrar-persona-img" style="border-bottom: 0.5px solid ##888888; padding-bottom: 10px;">
                        <div class="col-md-3">
                          <img class="rounded-circle"
                          alt="User Image"
                          :src="a.s3_url" 
                          style="margin-left:-10px; width:100px; height:100px;"/>
                        </div>
                        <div class="col-md-9">
                          <h5 style="font-size: 14px; margin-top: 7px;">{{ a.name + ' ' + a.first_surname + ' ' + a.second_surname }}</h5>
                          <p style="font-size: 12px; margin-top:-5px;">Nacimiento: {{ a.date_birthdate }}</p>
                          <p style="font-size: 12px; margin-top:-12px;">{{ a.province }} - {{ a.departament }}</p>
                          <p style="font-size: 12px; margin-top:-12px;">Fecha Postulacion: {{ a.date_application }}</p>
                        </div>
                      </div>
                    </div>
                    <div v-if="list_applicants_finalists.length == 0" class="row mostrar-persona-img" style="border-bottom: 0.5px solid #888888; padding-bottom: 10px;">
                      <span style="color:#888888; padding: 25px 0;"> Aún no hay postulantes pre-seleccionados
                        <!-- <i style="padding-left:20px;" class="fa fa-chevron-right"></i> -->
                      </span>
                    </div>
                  </div>
                  <div class="col-md-8 zona-mostrar-seleccion">
                    <div class="blk-botonera-aprobacion" v-if="detailsApplicant.id">
                        <button class="btn btn-danger" @click="processApplicant('D', detailsApplicant.id)"><i class="fa fa-cancel" style="padding-right:6px"></i>Descartar</button>
                        <button class="btn btn-success" @click="processApplicant('C', detailsApplicant.id)"><i class="fa fa-arrow-right" style="padding-right:6px"></i> A Contratados</button>
                    </div>

                    <div class="row blk-cabecera mt-2" v-if="detailsApplicant.id">
                        <div class="col-md-4 blk-cabecera-img">
                            <img class="avatar-img rounded-circle" alt="User Image" :src="detailsApplicant.s3_url" style="width:90%; height:auto;"/>
                        </div>
                        <div class="col-md-8">
                            <h4 class="_title">{{detailsApplicant.name + ' ' + detailsApplicant.first_surname + ' ' + detailsApplicant.second_surname}}</h4>
                            <p class="_detail"><span>Nacimiento: {{ detailsApplicant.date_birthdate }}</span> </p>
                            <p class="_subdetail"><span> {{ detailsApplicant.departament }} | {{ detailsApplicant.province }} | {{ detailsApplicant.district }}</span></p>
                            <p class="_subdetail">Fecha Postulacion: {{ detailsApplicant.date_application }}</p>
                            <div class="row">
                                <div class="col-sm-4 _fono">
                                    <a><i class="fa fa-phone"></i> {{detailsApplicant.n_phone}}</a>
                                </div>
                                <div class="col-sm-8 _subdetail">
                                    <i class="fa fa-envelope"></i>  {{detailsApplicant.email}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="blk-info mt-3" v-if="detailsApplicant.id">
                        <div class="blk-subinfo">
                            <h4>
                              Perfil y objetivos 
                              <a
                              href="javascript:void(0);"
                              class="btn btn-sm btn-primary"
                              @click="viewAnswers(detailsApplicant.id)"
                              style="font-size:14px;margin-left:10px;"
                              ><i class="far fa-eye"> Respuestas</i>
                              <!-- data-bs-toggle="modal"
                              data-bs-target="#view_answers" -->
                              </a>
                            </h4>
                            <div class="flex-dos-cols">
                                <!-- <div><strong>Resumen</strong></div> -->
                                <div class="text-justify">{{detailsApplicant.pers_description}}</div>
                            </div>
                            <div class="mt-3">
                                <!-- <div><strong>CV Adjunto</strong></div> -->
                                <div>
                                  <a
                                  :href="detailsApplicant.cv_s3_url"
                                  class="btn btn-sm btn-agv-dos"
                                  style="font-size:14px;margin-left:10px;"
                                  target="_blank"
                                  ><i class="fa-solid fa-file-lines">Ver CV</i>
                                  </a>
                                </div>
                            </div>
                        </div>

                        <div class="blk-subinfo mt-4">
                            <h4>Experiencia</h4>
                            <div v-for="el, index of ExpLabApplicant" :key="index" class="flex-dos-cols">
                                <div class="col-left">
                                    <strong>{{ el.start_date}} - {{ el.present == true ? 'Actualidad' : el.end_date }}</strong>
                                    <!-- <p class="text-body-tertiary">(3 años y 1 mes)</p> -->
                                </div>
                                <div>
                                    <strong>{{ el.work_pos }}</strong>
                                    <div class="text-body-tertiary">{{ el.company }}</div>
                                    <div class="text-justify">{{ el.description }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="blk-subinfo mt-4">
                            <h4>Formación</h4>
                            <div  v-for="e, index of educationApplicant" :key="index" class="flex-dos-cols">
                                <div class="col-left">
                                  <strong>{{ e.start_date}} - {{ e.present == true ? 'Actualidad' : e.end_date }}</strong>
                                </div>
                                <div>
                                    <strong>{{ e.career }}</strong>
                                    <div>{{ e.inst_univ }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="blk-subinfo tm-4">
                            <h4>Información Adicional</h4>
                            <div>
                                <div><i class="fa fa-check"></i>Licencia de conducir: {{ detailsApplicant.drivers_license == true ? 'SI' : 'NO' }}</div>
                                <div><i class="fa fa-check"></i> Disponibilidad de viajar:  {{ detailsApplicant.availab_change_travel == true ? 'SI' : 'NO' }}</div>
                                <div><i class="fa fa-check"></i> Disponibilidad de cambio de residencia:  {{ detailsApplicant.availab_change_resid == true ? 'SI' : 'NO' }}</div>
                            </div>
                        </div>

                        <div class="blk-subinfo mt-4">
                            <h4>Datos Personales y de contacto</h4>
                            <div>
                                <div><strong>{{ detailsApplicant.name + ' ' + detailsApplicant.first_surname + ' ' + detailsApplicant.second_surname }}</strong></div>
                                <div class="text-body-tertiary">Sexo: {{ detailsApplicant.gender }} (Fec. nacimiento: {{ detailsApplicant.birthdate }})</div>
                                <div class="text-body-tertiary">{{ detailsApplicant.nationality }} - DNI: {{ detailsApplicant.n_doc }}</div>
                                <div class="text-info" style="font-size: .8em;">
                                    <i class="fa fa-phone"></i> {{ detailsApplicant.n_phone }}
                                </div>
                                <div class="text-info" style="font-size: .8em;">
                                    <i class="fa fa-envelope"></i> {{ detailsApplicant.email }}
                                </div>
                            </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="tab-pane show" id="tab-contratados">
                <div class="zona-mostrar row">
                  <div class="col-md-4 zona-mostrar-lista" >
                    <div v-for="(a, index) in list_applicants_hired" :key="index" class="mostrar-persona" @click="getDetailsApplicant(a.id)">
                      <div class="row mostrar-persona-img" style="border-bottom: 0.5px solid #888888; padding-bottom: 10px;">
                        <div class="col-md-3">
                          <img class="rounded-circle"
                          alt="User Image"
                          :src="a.s3_url" 
                          style="margin-left:-10px; width:100px; height:100px;"/>
                        </div>
                        <div class="col-md-9">
                          <h5 style="font-size: 14px; margin-top: 7px;">{{ a.name + ' ' + a.first_surname + ' ' + a.second_surname }}</h5>
                          <p style="font-size: 12px; margin-top:-5px;">Nacimiento: {{ a.date_birthdate }}</p>
                          <p style="font-size: 12px; margin-top:-12px;">{{ a.province }} - {{ a.departament }}</p>
                          <p style="font-size: 12px; margin-top:-12px;">Fecha Postulacion: {{ a.date_application }}</p>
                        </div>
                      </div>
                    </div>
                    <div v-if="list_applicants_hired.length == 0" class="row mostrar-persona-img" style="border-bottom: 0.5px solid #888888; padding-bottom: 10px;">
                      <span style="color:#888888; padding: 25px;"> Aún no hay postulantes contratados
                        <!-- <i style="padding-left:20px;" class="fa fa-chevron-right"></i> -->
                      </span>
                    </div>
                  </div>
                  <div class="col-md-8 zona-mostrar-seleccion">
                    <!-- <div class="blk-botonera-aprobacion">
                        <button class="btn btn-danger"><i class="fa fa-cancel" style="padding-right:6px"></i>Descartar</button>
                        <button class="btn btn-success"><i class="fa fa-arrow-right" style="padding-right:6px"></i> A Finalistas</button>
                    </div> -->

                    <div class="row blk-cabecera mt-2" v-if="detailsApplicant.id">
                        <div class="col-md-4 blk-cabecera-img">
                            <img class="avatar-img rounded-circle" alt="User Image" :src="detailsApplicant.s3_url" style="width:90%; height:auto;"/>
                        </div>
                        <div class="col-md-8">
                            <h4 class="_title">{{detailsApplicant.name + ' ' + detailsApplicant.first_surname + ' ' + detailsApplicant.second_surname}}</h4>
                            <p class="_detail"><span>Nacimiento: {{ detailsApplicant.date_birthdate }}</span> </p>
                            <p class="_subdetail"><span> {{ detailsApplicant.departament }} | {{ detailsApplicant.province }} | {{ detailsApplicant.district }}</span></p>
                            <p class="_subdetail">Fecha Postulacion: {{ detailsApplicant.date_application }}</p>
                            <div class="row">
                                <div class="col-sm-4 _fono">
                                    <a><i class="fa fa-phone"></i> {{detailsApplicant.n_phone}}</a>
                                </div>
                                <div class="col-sm-8 _subdetail">
                                    <i class="fa fa-envelope"></i>  {{detailsApplicant.email}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="blk-info mt-3" v-if="detailsApplicant.id">
                        <div class="blk-subinfo">
                            <h4>
                              Perfil y objetivos 
                              <a
                              href="javascript:void(0);"
                              class="btn btn-sm btn-primary"
                              @click="viewAnswers(detailsApplicant.id)"
                              style="font-size:14px;margin-left:10px;"
                              ><i class="far fa-eye"> Respuestas</i>
                              <!-- data-bs-toggle="modal"
                              data-bs-target="#view_answers" -->
                              </a>
                            </h4>
                            <div class="flex-dos-cols">
                                <!-- <div><strong>Resumen</strong></div> -->
                                <div class="text-justify">{{detailsApplicant.pers_description}}</div>
                            </div>
                            <div class="mt-3">
                                <!-- <div><strong>CV Adjunto</strong></div> -->
                                <div>
                                  <a
                                  :href="detailsApplicant.cv_s3_url"
                                  class="btn btn-sm btn-agv-dos"
                                  style="font-size:14px;margin-left:10px;"
                                  target="_blank"
                                  ><i class="fa-solid fa-file-lines">Ver CV</i>
                                  </a>
                                </div>
                            </div>
                        </div>

                        <div class="blk-subinfo mt-4">
                            <h4>Experiencia</h4>
                            <div v-for="el, index of ExpLabApplicant" :key="index" class="flex-dos-cols">
                                <div class="col-left">
                                    <strong>{{ el.start_date}} - {{ el.present == true ? 'Actualidad' : el.end_date }}</strong>
                                    <!-- <p class="text-body-tertiary">(3 años y 1 mes)</p> -->
                                </div>
                                <div>
                                    <strong>{{ el.work_pos }}</strong>
                                    <div class="text-body-tertiary">{{ el.company }}</div>
                                    <div class="text-justify">{{ el.description }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="blk-subinfo mt-4">
                            <h4>Formación</h4>
                            <div  v-for="e, index of educationApplicant" :key="index" class="flex-dos-cols">
                                <div class="col-left">
                                  <strong>{{ e.start_date}} - {{ e.present == true ? 'Actualidad' : e.end_date }}</strong>
                                </div>
                                <div>
                                    <strong>{{ e.career }}</strong>
                                    <div>{{ e.inst_univ }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="blk-subinfo tm-4">
                            <h4>Información Adicional</h4>
                            <div>
                                <div><i class="fa fa-check"></i>Licencia de conducir: {{ detailsApplicant.drivers_license == true ? 'SI' : 'NO' }}</div>
                                <div><i class="fa fa-check"></i> Disponibilidad de viajar:  {{ detailsApplicant.availab_change_travel == true ? 'SI' : 'NO' }}</div>
                                <div><i class="fa fa-check"></i> Disponibilidad de cambio de residencia:  {{ detailsApplicant.availab_change_resid == true ? 'SI' : 'NO' }}</div>
                            </div>
                        </div>

                        <div class="blk-subinfo mt-4">
                            <h4>Datos Personales y de contacto</h4>
                            <div>
                                <div><strong>{{ detailsApplicant.name + ' ' + detailsApplicant.first_surname + ' ' + detailsApplicant.second_surname }}</strong></div>
                                <div class="text-body-tertiary">Sexo: {{ detailsApplicant.gender }} (Fec. nacimiento: {{ detailsApplicant.birthdate }})</div>
                                <div class="text-body-tertiary">{{ detailsApplicant.nationality }} - DNI: {{ detailsApplicant.n_doc }}</div>
                                <div class="text-info" style="font-size: .8em;">
                                    <i class="fa fa-phone"></i> {{ detailsApplicant.n_phone }}
                                </div>
                                <div class="text-info" style="font-size: .8em;">
                                    <i class="fa fa-envelope"></i> {{ detailsApplicant.email }}
                                </div>
                            </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>


              <div class="tab-pane show" id="tab-descartados">
                <div class="zona-mostrar row">
                  <div class="col-md-4 zona-mostrar-lista" >
                    <div v-for="(a, index) in list_applicants_discarded" :key="index" class="mostrar-persona" @click="getDetailsApplicant(a.id)">
                      <div class="row mostrar-persona-img" style="border-bottom: 0.5px solid #888888; padding-bottom: 10px;">
                        <div class="col-md-3">
                          <img class="rounded-circle"
                          alt="User Image"
                          :src="a.s3_url" 
                          style="margin-left:-10px; width:100px; height:100px;"/>
                        </div>
                        <div class="col-md-9">
                          <h5 style="font-size: 14px; margin-top: 7px;">{{ a.name + ' ' + a.first_surname + ' ' + a.second_surname }}</h5>
                          <p style="font-size: 12px; margin-top:-5px;">Nacimiento: {{ a.date_birthdate }}</p>
                          <p style="font-size: 12px; margin-top:-12px;">{{ a.province }} - {{ a.departament }}</p>
                          <p style="font-size: 12px; margin-top:-12px;">Fecha Postulacion: {{ a.date_application }}</p>
                        </div>
                      </div>
                    </div>
                    <div v-if="list_applicants_discarded.length == 0" class="row mostrar-persona-img" style="border-bottom: 0.5px solid #888888; padding-bottom: 10px;">
                      <span style="color:#888888; padding: 25px 0;"> Aún no hay postulantes descartados
                        <!-- <i style="padding-left:20px;" class="fa fa-chevron-right"></i> -->
                      </span>
                    </div>
                  </div>
                  <div class="col-md-8 zona-mostrar-seleccion">
                    <div class="blk-botonera-aprobacion" v-if="detailsApplicant.id">
                        <!-- <button class="btn btn-danger"><i class="fa fa-cancel" style="padding-right:6px"></i>Descartar</button> -->
                        <button class="btn btn-success" @click="processApplicant('P', detailsApplicant.id)"><i class="fa fa-arrow-right" style="padding-right:6px"></i> A Pre-seleccionado</button>
                    </div>

                    <div class="row blk-cabecera mt-2" v-if="detailsApplicant.id">
                        <div class="col-md-4 blk-cabecera-img">
                            <img class="avatar-img rounded-circle" alt="User Image" :src="detailsApplicant.s3_url" style="width:90%; height:auto;"/>
                        </div>
                        <div class="col-md-8">
                            <h4 class="_title">{{detailsApplicant.name + ' ' + detailsApplicant.first_surname + ' ' + detailsApplicant.second_surname}}</h4>
                            <p class="_detail"><span>Nacimiento: {{ detailsApplicant.date_birthdate }}</span> </p>
                            <p class="_subdetail"><span> {{ detailsApplicant.departament }} | {{ detailsApplicant.province }} | {{ detailsApplicant.district }}</span></p>
                            <p class="_subdetail">Fecha Postulacion: {{ detailsApplicant.date_application }}</p>
                            <div class="row">
                                <div class="col-sm-4 _fono">
                                    <a><i class="fa fa-phone"></i> {{detailsApplicant.n_phone}}</a>
                                </div>
                                <div class="col-sm-8 _subdetail">
                                    <i class="fa fa-envelope"></i>  {{detailsApplicant.email}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="blk-info mt-3" v-if="detailsApplicant.id">
                        <div class="blk-subinfo">
                            <h4>
                              Perfil y objetivos 
                              <a
                              href="javascript:void(0);"
                              class="btn btn-sm btn-primary"
                              @click="viewAnswers(detailsApplicant.id)"
                              style="font-size:14px;margin-left:10px;"
                              ><i class="far fa-eye"> Respuestas</i>
                              <!-- data-bs-toggle="modal"
                              data-bs-target="#view_answers" -->
                              </a>
                            </h4>
                            <div class="flex-dos-cols">
                                <div><strong>Resumen</strong></div>
                                <div class="text-justify">{{detailsApplicant.pers_description}}</div>
                            </div>
                            <div class="mt-3">
                                <div><strong>CV Adjunto</strong></div>
                                <div>
                                  <a
                                  :href="detailsApplicant.cv_s3_url"
                                  class="btn btn-sm btn-agv-dos"
                                  style="font-size:14px;margin-left:10px;"
                                  target="_blank"
                                  ><i class="fa-solid fa-file-lines">Ver CV</i>
                                  </a>
                                </div>
                            </div>
                        </div>

                        <div class="blk-subinfo mt-4">
                            <h4>Experiencia</h4>
                            <div v-for="el, index of ExpLabApplicant" :key="index" class="flex-dos-cols">
                                <div class="col-left">
                                    <strong>{{ el.start_date}} - {{ el.present == true ? 'Actualidad' : el.end_date }}</strong>
                                    <!-- <p class="text-body-tertiary">(3 años y 1 mes)</p> -->
                                </div>
                                <div>
                                    <strong>{{ el.work_pos }}</strong>
                                    <div class="text-body-tertiary">{{ el.company }}</div>
                                    <div class="text-justify">{{ el.description }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="blk-subinfo mt-4">
                            <h4>Formación</h4>
                            <div  v-for="e, index of educationApplicant" :key="index" class="flex-dos-cols">
                                <div class="col-left">
                                  <strong>{{ e.start_date}} - {{ e.present == true ? 'Actualidad' : e.end_date }}</strong>
                                </div>
                                <div>
                                    <strong>{{ e.career }}</strong>
                                    <div>{{ e.inst_univ }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="blk-subinfo tm-4">
                            <h4>Información Adicional</h4>
                            <div>
                                <div><i class="fa fa-check"></i>Licencia de conducir: {{ detailsApplicant.drivers_license == true ? 'SI' : 'NO' }}</div>
                                <div><i class="fa fa-check"></i> Disponibilidad de viajar:  {{ detailsApplicant.availab_change_travel == true ? 'SI' : 'NO' }}</div>
                                <div><i class="fa fa-check"></i> Disponibilidad de cambio de residencia:  {{ detailsApplicant.availab_change_resid == true ? 'SI' : 'NO' }}</div>
                            </div>
                        </div>

                        <div class="blk-subinfo mt-4">
                            <h4>Datos Personales y de contacto</h4>
                            <div>
                                <div><strong>{{ detailsApplicant.name + ' ' + detailsApplicant.first_surname + ' ' + detailsApplicant.second_surname }}</strong></div>
                                <div class="text-body-tertiary">Sexo: {{ detailsApplicant.gender }} (Fec. nacimiento: {{ detailsApplicant.birthdate }})</div>
                                <div class="text-body-tertiary">{{ detailsApplicant.nationality }} - DNI: {{ detailsApplicant.n_doc }}</div>
                                <div class="text-info" style="font-size: .8em;">
                                    <i class="fa fa-phone"></i> {{ detailsApplicant.n_phone }}
                                </div>
                                <div class="text-info" style="font-size: .8em;">
                                    <i class="fa fa-envelope"></i> {{ detailsApplicant.email }}
                                </div>
                            </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /View Modal -->


    <!-- Answers of Applicant Modal -->
    <div class="modal fade custom-modal" id="view_answers">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">Respuestas del Cuestionario</h4>
            <button type="button" class="close" data-bs-dismiss="modal">
              <span>&times;</span>
            </button>
          </div>
  
          <!-- Modal body -->
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div v-for="(r,index) of question_answers" :key="index">
                  <p class="mt-2">Pregunta: {{r.pregunta}}</p>
                  <p style="border-bottom: 1px solid lightgray; margin-top: -5px; padding-bottom:5px">Respuesta: {{r.respuesta}}</p>
                </div>
              </div>
              <div class="col-md-9"></div>
              <div class="col-md-3 mt-3">
                <button 
                type="button" 
                class="btn" 
                data-bs-dismiss="modal" 
                style="
                  border: 1px solid #6BB545; 
                  color: #6BB545;
                  width:100%"
                >
                Cancelar
                </button>
              </div>
            </div>

            <!-- <form @submit.prevent="">
              <div class="form-group">
                <label>Párrafo</label>
                <textarea 
                  class="form-control" 
                  name="txt-parrafo" 
                  style="min-height:140px"  
                  placeholder="Párrafo"
                  >
                </textarea>
              </div>
              <div class="form-group">
                <label>Imagen</label>
                <input 
                type="file" 
                class="form-control" 
                name="txt-imagen" 
                accept="image/png, image/gif, image/jpeg"
                @change="handlePhotoChangeJobOffer"
                />
                <div class="img-preview">
                  <img :src="img_preview_joboffer"/>
                </div>
              </div>
              <div class="mt-4">
                <button type="submit" class="btn btn-agv-dos btn-block" data-bs-dismiss="modal">Guardar</button>
              </div> 
            </form>-->
          </div>
        </div>
      </div>
    </div>
    <!-- /Answers of Applicant Modal -->


  </template>
    
<script>

  import {DatePicker} from "v-calendar";

  const fnbaseToCols = (column) => {
    return {
          title: column.title,
          dataIndex: column.dataIndex,
          key: column.dataIndex,
          sorter : false,
          class: column?.class ?? "" ,
      }
  };
  
  const baseColsTableJobOffers = [
    { title: "Puesto", dataIndex: "work_pos"},
    { title: "N° Vacantes", dataIndex: "n_vacancy"},
    { title: "Area", dataIndex: "area"},
    { title: "Sede o Lugar", dataIndex: "place"},
    { title: "Periodo", dataIndex: "period"},
    { title: "N° Postulantes", dataIndex: "num_postulantes"},
    { title: "Publicado por", dataIndex: "fullname"},
    { title: "Fecha Publicación", dataIndex: "created_date"},
    { title: "Acciones", dataIndex: "id", class: "text-end"},
  ];
  const columnsTableJobOffers = baseColsTableJobOffers.map ( fnbaseToCols );
  
  import axiosIns from '@/plugins/axios.js';
  import { ref } from "vue";
  import { Modal } from 'bootstrap';
  import Quill from 'quill';
  import 'quill/dist/quill.snow.css';
  import {router} from "@/router";
  // import Datepicker from '../src/datepicker/Datepicker.vue'
  const currentDate = ref(new Date());
  
  export default {
    components: {DatePicker},
    data() {
      return {
        foc: false,
        columnsTableJobOffers,
        title: "Ofertas laborales",
        text: "Mantenimientos Páginas",
        text1: "Nuestros Colaboradores",
        filterInputsDisplay: "none",
        startdate: currentDate,

        selectedAction: null,
        actions: [
            {value:'new', text:'Crear nueva oferta'},
            {value:'clone', text:'Clonar oferta existente'},
        ],

        showModalNewJobOffer:false,

        id_joboffer:null,
        work_position: null,
        complement: null,

        n_vacancy: null,
        date_hire: new Date(),
        reference: null,

        selectedWorkModality: null,
        selectedTypeContract: null,
        selectedWorkingDay: null,

        work_modalities: [
            {value:'PRESENCIAL', text:'Presencial'},
            {value:'REMOTO', text:'Remoto'},
        ],
        types_contracts: [
            {value:'INCREMENTO ACTIVIDADES', text:'Incremento de actividades'},
            {value:'CONTRATO DE EMERGENCIA', text:'Contrato de Emergencia'},
            {value:'CONTRATO OCASIONAL', text:'Contrato Ocasional'},
            {value:'CONTRATO DE TEMPORADA', text:'Contrato de Temporada'},
            {value:'CONTRATO DE SUPLENCIA', text:'Contrato de Suplencia'},
            {value:'CONTRATO DE OBRA DETERMINADA O SERVICIO ESPECIFICO', text:'Contrato de Obra Determinada o Servicio Especifico'},
            {value:'CONTRATO INTERMITENTE', text:'Contrato Intermitente'},
            {value:'CONTRATO POR INICIO O INCREMENTO DE ACTIVIDAD', text:'Contrato por Inicio o Incremento de Actividad'},
            {value:'CONTRATO POR NECESIDADES DEL MERCADO', text:'Contrato por Necesidades del Mercado'},
            {value:'CONTRATO POR RECONVERSION EMPRESARIAL', text:'Contrato por Reconversion Empresarial'},
            {value:'CONTRATO A PLAZO INDETERMINADO', text:'Contrato a Plazo Indeterminado'},
        ],
        labor_journeys: [
            {value:'COMPLETO', text:'Tiempo Completo'},
            {value:'PARCIAL', text:'Tiempo Parcial'},
            {value:'HORAS', text:'Por horas'},
        ],
        
        min_salary_range: null,
        max_salary_range: null,

        selectedPlace: null,
        places: [
            {value:'LIMA', text:'Oficina Lima'},
            {value:'CHICLAYO', text:'Oficina Chiclayo'},
            {value:'OLMOS', text:'Fundo Olmos'},
        ],
        area: null,
        selectedPeriod: null,
        periods:[
          {value:'FIJO', text:'FIJO'},
          {value:'EVENTUAL', text:'EVENTUAL'}
        ],
        description: null,
        functions: null,
        requirements:null,

        selectedExperienceTime: null,
        experiencie_time: [
            {value:'SIN EXPERIENCIA', text:'Sin Experiencia'},
            {value:'MENOR A 1 ANIO', text:'Menor a 1 año'},
            {value:'ENTRE 1 Y 2 ANIOS', text:'De 1 a 2 años'},
            {value:'ENTRE 3 Y 5 ANIOS', text:'De 3 a 5 años'},
            {value:'MAYOR A 5 ANIOS', text:'Mayor a 5 años'},
        ],

        selectedLevelEducation: null,
        levelseducation: [
            {value:'TECNICO', text:'Tecnico'},
            {value:'BACHILLER', text:'Bachiller'},
            {value:'UNIVERSITARIO', text:'Universitario'},
            {value:'MAESTRIA', text:'Maestria'},
            {value:'DOCTORADO', text:'Doctorado'},
        ],

        img_preview_joboffer: null,
        img_joboffer: null,
        
        dataTableJobOffers: null,
        dataTableFiltJobOffers: null,
        
        quiz_questions:[

        ],
        
        newQuestion: {
          question: "",
          type_quest: "A",
          time_quest: '60',
          alt_one:null,
          alt_two:null,
          alt_three:null,
          alt_four:null,
          alt_five:null,
          alt_six:null,

          weight_one:null,
          weight_two:null,
          weight_three:null,
          weight_four:null,
          weight_five:null,
          weight_six:null,
        },

        searched_value:null,
        language: null,

        // ---------------
        id_offer_actual: null,
        list_applicants: [],
        list_applicants_finalists: [],
        list_applicants_hired: [],
        list_applicants_discarded: [],

        detailsApplicant: [],
        educationApplicant: [],
        ExpLabApplicant: [],
        LanguagesApplicant: [],

        question_answers:[],

        // Detalle de oferta Seleccionada para ver Detalle de Postulantes
        all_info_offer_selected: [],

        usuario: null,
        dialogLoading: false,

      };
    },
    beforeRouteEnter(to, from, next){
      if (!localStorage.getItem('userDataAdmin')) {
        router.push('/admin/login');
      }else{
        next()
      }
    },
    mounted(){
      this.initQuillEditors();
      this.getJobOffers();
      this.usuario = JSON.parse( localStorage.getItem("userDataAdmin") );

      (function () {
          "use strict";
          window.addEventListener(
              "load",
              function () {
              // Fetch all the forms we want to apply custom Bootstrap validation styles to
              var forms = document.getElementsByClassName("needs-validation");
              // Loop over them and prevent submission
              var validation = Array.prototype.filter.call(forms, function (form) {
                  form.addEventListener(
                  "submit",
                  function (event) {
                      if (form.checkValidity() === false) {
                      event.preventDefault();
                      event.stopPropagation();
                      }
                      form.classList.add("was-validated");
                  },
                  false
                  );
              });
              },
              false
          );
      })();
    },
    methods: {
      handleDate(modelDate){
        console.log("información de la fecha", this.formatDate(modelDate));
      },
      initQuillEditors() {
        this.descriptionEditor = new Quill(this.$refs.descriptionEditor, {
            theme: 'snow',
            modules: {
            toolbar: true
            }
        });

        this.functionsEditor = new Quill(this.$refs.functionsEditor, {
            theme: 'snow',
            modules: {
            toolbar: true
            }
        });

        this.requirementsEditor = new Quill(this.$refs.requirementsEditor, {
            theme: 'snow',
            modules: {
            toolbar: true
            }
        });

        // Cargar el contenido en los editores si ya hay datos
        this.descriptionEditor.root.innerHTML = this.description || '';
        this.functionsEditor.root.innerHTML = this.functions || '';
        this.requirementsEditor.root.innerHTML = this.requirements || '';

        // Actualizar el modelo cuando cambie el contenido
        this.descriptionEditor.on('text-change', () => {
            this.description = this.descriptionEditor.root.innerHTML;
        });

        this.functionsEditor.on('text-change', () => {
            this.functions = this.functionsEditor.root.innerHTML;
        });

        this.requirementsEditor.on('text-change', () => {
            this.requirements = this.requirementsEditor.root.innerHTML;
        });

      },

      handlePhotoChangeJobOffer(event) {
        const file = event.target.files[0];
        if (file) {
            this.img_joboffer = file;
            this.img_preview_joboffer= URL.createObjectURL(file);
        }
      },

      validateAndSubmit(event) {
        const yo = this 
        event.preventDefault();
        event.stopPropagation();
        const form = event.target;

        if (form.checkValidity() === false) {
            form.classList.add('was-validated');
        } else {
            yo.addJobOffers();
            form.classList.remove('was-validated');
            form.reset();
            const modalElement = document.getElementById('add_joboffer');
            const modal = Modal.getInstance(modalElement) || new Modal(modalElement);
            modal.hide();  // Esta línea cierra el modal manualmente
        }
      },
  
      addJobOffers(){
        // console.log("Registrando oferta laboral")
        const yo = this       
        const formData = new FormData();
        yo.dialogLoading = true;
        formData.append('work_position', yo.work_position.toUpperCase());
        formData.append('complement', yo.complement);
        formData.append('n_vacancy', yo.n_vacancy);
        formData.append('date_hire', yo.formatDate(yo.date_hire));
        formData.append('reference', yo.reference);
        formData.append('work_modality', yo.selectedWorkModality);
        formData.append('type_contract', yo.selectedTypeContract);
        formData.append('working_day', yo.selectedWorkingDay);
        formData.append('min_salary_range', yo.min_salary_range);
        formData.append('max_salary_range', yo.max_salary_range);
        formData.append('place', yo.selectedPlace);
        formData.append('area', yo.area);
        formData.append('period', yo.selectedPeriod);
        formData.append('description', yo.description);
        formData.append('functions', yo.functions);
        formData.append('requirements', yo.requirements);
        formData.append('experience_time', yo.selectedExperienceTime);
        formData.append('level_education', yo.selectedLevelEducation);

        formData.append('quiz_questions', JSON.stringify(yo.quiz_questions));

        formData.append('img_joboffer', yo.img_joboffer);
        formData.append('language', yo.language);
        formData.append('key_user', this.usuario.id_usuario);
  
        const config = {
          method: 'post',
          url: yo.id_offer_actual == null ? '/talentoagv/createJobOffer/' : '/talentoagv/updateJobOffer/'+yo.id_offer_actual,
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          data: formData,
        }
  
        axiosIns(config)
          .then(function (response) {
            // console.log(response.data)
            if (response.data['is_error'][0] === false){
              yo.$toastr.success(response.data['message'], 'Éxito')
              yo.getJobOffers()
            //   yo.clearValuesColaborator()
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.$toastr.error(response.data['message'], 'Error')
          })
          .finally(function (){
            yo.dialogLoading = false;
          })
      },
  
      getJobOffers(){
        const yo = this
        yo.dataTableJobOffers=[]
        yo.dataTableFiltJobOffers=[]
        yo.dialogLoading = true;
        const config = {
          method: 'get',
          url: '/talentoagv/readJobOffers/',
        }
  
        if(this.$store.getters.currentAdminLanguage == 'es'){
          yo.language = '1'
        }
        else if(this.$store.getters.currentAdminLanguage == 'en'){
          yo.language = '2'
        }
  
        axiosIns(config)
          .then(function (response) {
            // console.log(response.data['result'])
            if (response.data['is_error'] === false){
                let resultado = response.data['result']
                for(let r of resultado){
                    let fullName = r['first_name'] + ' ' + r['last_name'];
                    r['fullname'] = fullName; 
                }
                yo.dataTableJobOffers = resultado
                yo.dataTableFiltJobOffers = resultado
                // for(let r of resultado){
                //     if(r['key_idioma_id'] == yo.language){
                //         yo.dataTableJobOffers.push(r)
                //         yo.dataTableFiltJobOffers.push(r)
                //     }
                // }
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.$toastr.error(response.data['message'], 'Error')
          })
          .finally(function (){
            yo.dialogLoading = false;
          })
      },

      loadCloneModalJobOffer(datos){
        // console.log(datos)
        // console.log(datos['experience_time'])
        const yo = this
        let id = datos['id']
        yo.work_position = datos['work_pos']
        yo.complement = datos['complement']
        yo.n_vacancy = datos['n_vacancy']
        yo.date_hire = datos['end_date']
        yo.reference = datos['reference']
        yo.selectedWorkModality = datos['work_modality']
        yo.selectedTypeContract = datos['type_contract']
        yo.selectedWorkingDay=datos['working_day']
        yo.min_salary_range=datos['min_salary_range']
        yo.max_salary_range=datos['max_salary_range']
        yo.selectedPlace = datos['place']
        yo.area = datos['area']
        yo.selectedPeriod = datos['period']
        yo.description = datos['description']
        yo.functions = datos['functions']
        yo.requirements = datos['requirements']
        yo.selectedExperienceTime = datos['experience_time']
        yo.selectedLevelEducation = datos['level_education']
        yo.img_joboffer = datos['photo']
        yo.img_preview_joboffer = datos['s3_url']

        // Establecer el contenido de los editores de Quill
        this.descriptionEditor.root.innerHTML = datos['description'] || '';
        this.functionsEditor.root.innerHTML = datos['functions'] || '';
        this.requirementsEditor.root.innerHTML = datos['requirements'] || '';

        //Consulto las preguntas que pertenecen a esta oferta
        const data = JSON.stringify({
          id : id,
        })

        const config = {
          method: 'post',
          url: '/talentoagv/getQuestionsOptions/',
          headers: {
            'Content-Type': 'application/json'
          },
          data: data,
        }
  
        axiosIns(config)
          .then(function (response) {
            // console.log(response.data['result'])
            if (response.data['is_error'][0] === false){
              yo.quiz_questions = response.data['result']
              // yo.$toastr.success(response.data['message'], 'Éxito')
              // yo.getJobOffers()
            }
          })
          .catch(function (error) {
            console.log(error);
            // yo.$toastr.error(response.data['message'], 'Error')
          })
          .finally(function (){
            
          })

      },

      loadEditModalCollaborator(all_info_offer){
        // console.log("toda la información de la oferta laboral", all_info_offer);
        const yo = this
        // console.log("fecha fin de puesto", yo.formatDate(new Date(all_info_offer['end_date'].split('/').reverse().join('-'))))
        yo.dialogLoading = true;
        yo.work_position = all_info_offer['work_pos']
        yo.n_vacancy = all_info_offer['n_vacancy']
        // const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        yo.date_hire = new Date(all_info_offer['end_date'].split('/').reverse().join('-'))
        yo.selectedWorkModality = all_info_offer['work_modality']
        yo.selectedTypeContract = all_info_offer['type_contract']
        yo.selectedWorkingDay = all_info_offer['working_day']
        yo.selectedPlace = all_info_offer['place']
        yo.area = all_info_offer['area']
        yo.selectedPeriod = all_info_offer['period']

        // Cargar el contenido en los editores si ya hay datos
        this.descriptionEditor.root.innerHTML = all_info_offer['description'];
        this.functionsEditor.root.innerHTML = all_info_offer['functions'];
        this.requirementsEditor.root.innerHTML = all_info_offer['requirements'];

        yo.selectedExperienceTime = all_info_offer['experience_time'];
        yo.selectedLevelEducation = all_info_offer['level_education'];
        yo.img_preview_joboffer = all_info_offer['s3_url']
        yo.id_offer_actual = all_info_offer['id'];

        axiosIns({
          method: 'post',
          url: '/talentoagv/getQuestionsOptions/',
          headers: {
            'Content-Type': 'application/json'
          },
          data: {
            id: all_info_offer['id'],
          }
        }).then(function (response) {
            if (response.data['is_error'] === false){
              console.log("la lista de preguntas son las siguientes", response.data['result'])
              yo.quiz_questions = response.data['result']
            }
        }).finally(function (){
          yo.dialogLoading = false;
        })
      },

      // getApplicantsByOffer(id_offer){
      getApplicantsByOffer(id_offer, all_info_offer){
        const yo = this
        yo.id_offer_actual = id_offer
        yo.all_info_offer_selected = all_info_offer
        console.log(yo.all_info_offer_selected)
        const data = JSON.stringify({
          id_job_offer : id_offer
        })

        // yo.dataTableApplicants=[]
        // yo.dataTableFiltApplicants=[]

        const config = {
          method: 'post',
          url: '/talentoagv/getApplicantsByOffer/',
          headers: {
              'Content-Type': 'application/json'
          },
          data: data,
        }

        axiosIns(config)
          .then(function (response) {
            // console.log(response.data['result'])
            if (response.data['is_error'] === false){
              let resultado = response.data['result']
              yo.list_applicants = resultado

              // Ahora separo por finalistas y contratados:
              yo.list_applicants_finalists = []
              yo.list_applicants_hired = []
              yo.list_applicants_discarded = []
              
              // I: Inscrito
              // F: Finalista cambiado a P: Pre-Seleccionado
              // C: Contratado
              // D: Descartado
              for(let f of resultado){
                if(f['status_post'] == 'P'){
                  yo.list_applicants_finalists.push(f)
                }else if(f['status_post'] == 'C'){
                  yo.list_applicants_hired.push(f)
                }else if(f['status_post'] == 'D'){
                  yo.list_applicants_discarded.push(f)
                }
              }

            }
          })
          .catch(function (error) {
              console.log(error);
              yo.$toastr.error(response.data['message'], 'Error')
          })
          .finally(function (){
              
          })
      },

      getDetailsApplicant(id_postulante){
        const yo = this
        yo.detailsApplicant = []
        for(let d of yo.list_applicants){
          if(d.id == id_postulante){
            yo.detailsApplicant = d
          }
        }

        // Obt. educacion, experiencia_lab y lenguajes
        const data = JSON.stringify({
          id : id_postulante
        })

        const config = {
            method: 'post',
            url: '/talentoagv/getApplicantEducationWorkExpLang/',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data,
        }

        axiosIns(config)
          .then(function (response) {
              // console.log(response.data['result'])
              if (response.data['is_error'] === false){
                  let resultado = response.data['result']

                  yo.educationApplicant = resultado[0]
                  yo.ExpLabApplicant = resultado[1]
                  yo.LanguagesApplicant = resultado[2]
                  

              }
          })
          .catch(function (error) {
              console.log(error);
              yo.$toastr.error(response.data['message'], 'Error')
          })
          .finally(function (){
              
          })


      },

      changeSection(){
        const yo = this
        yo.detailsApplicant = []
      },

      processApplicant(accion, id_applicant){
        // console.log(accion)
        // console.log(id_applicant)
        const yo = this
        yo.detailsApplicant = []
        const data = JSON.stringify({
          accion : accion,
          id_applicant : id_applicant,
          id_offer: yo.id_offer_actual,
        })

        const config = {
          method: 'post',
          url: '/talentoagv/processApplicant/',
          headers: {
              'Content-Type': 'application/json'
          },
          data: data,
        }

        axiosIns(config)
          .then(function (response) {
            console.log(response.data['result'])
            if (response.data['is_error'] === false){
              console.log("Se proceso la peticion")
              yo.getApplicantsByOffer(yo.id_offer_actual)
            }
          })
          .catch(function (error) {
              console.log(error);
              yo.$toastr.error(response.data['message'], 'Error')
          })
          .finally(function (){
              
          })

      },

      viewAnswers(id_applicant){
        const view_answers = new Modal(document.getElementById('view_answers'));
        view_answers.show();

        const yo = this
        const data = JSON.stringify({
          id_applicant : id_applicant,
          id_offer: yo.id_offer_actual,
        })

        const config = {
          method: 'post',
          url: '/talentoagv/getAnswerApplicant/',
          headers: {
              'Content-Type': 'application/json'
          },
          data: data,
        }

        axiosIns(config)
          .then(function (response) {

            if (response.data['is_error'] === false){
              let resultado = response.data['result']
              yo.question_answers = resultado

            }
          })
          .catch(function (error) {
              console.log(error);
              yo.$toastr.error(response.data['message'], 'Error')
          })
          .finally(function (){
              
          })

      },
  
    loadDeleteModalJobOffer(datos){
        const yo = this
        yo.id_joboffer = datos['id']
    },
  
    deleteJobOffer(){
      const yo = this       
      const data = JSON.stringify({
          id: yo.id_joboffer,
      })

      const config = {
          method: 'post',
          url: '/talentoagv/deleteJobOffer/',
          headers: {
          'Content-Type': 'application/json'
          },
          data: data,
      }

      axiosIns(config)
          .then(function (response) {
              if (response.data['is_error'] === false){
                  yo.$toastr.success(response.data['message'], 'Éxito')
                  yo.getJobOffers()
              }
          })
          .catch(function (error) {
              console.log(error);
              yo.$toastr.error(response.data['message'], 'Error')
          })
          .finally(function (){
          
          })
    },

    openAddQuestionModal() {
      const addQuestionModal = new Modal(document.getElementById('add_question'));
      addQuestionModal.show();
    },

    addQuestion() {
      console.log("A")
      if (this.newQuestion.question && this.newQuestion.type_quest) {

        this.quiz_questions.push({ ...this.newQuestion });

        this.newQuestion.question = "";
        this.newQuestion.type_quest = "";
        this.newQuestion.time_quest = "60";

        this.newQuestion.alt_one = "";
        this.newQuestion.alt_two = "";
        this.newQuestion.alt_three = "";
        this.newQuestion.alt_four = "";
        this.newQuestion.alt_five = "";
        this.newQuestion.alt_six = "";

        this.newQuestion.weight_one = "";
        this.newQuestion.weight_two = "";
        this.newQuestion.weight_three = "";
        this.newQuestion.weight_four = "";
        this.newQuestion.weight_five = "";
        this.newQuestion.weight_six = "";

      }
    },

    deleteQuestion(index) {
      this.quiz_questions.splice(index, 1);
    },

    formatDate(date) {
      if (!date) return ''; // En caso de que la fecha sea nula o indefinida
      const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      return new Date(date).toLocaleDateString('es-ES', options);
    }
    },
  };
  </script>

<style scoped>
    .quill-editor {
    height: 200px; /* Ajusta la altura según tus necesidades */
    }

    #add_question .modal-content {
      box-shadow: 0 8px 16px rgba(0, 0, 0, 0.5);
    }

    .agv-color{
      color : #6BB545
    }
</style>
  